export default "__VITE_ASSET__Dvm5d6Up__"